import React from "react";
import { Box, Typography, Chip, Button, TextField } from "@mui/material";
import PrintIcon from "@mui/icons-material/Print";
import { jwtDecode } from "jwt-decode";

import { accountExpenseDocument } from "../../api/Expenses/expenseAccountingApi";

const getStatusColor = (status) => {
  switch (status) {
    case "draft":
      return "warning";
    case "closed":
      return "error";
    default:
      return "success";
  }
};

const ExpenseDocumentHeader = ({ document }) => {
  const API_URL = process.env.REACT_APP_API_URL;

  const [numeroAsiento, setNumeroAsiento] = React.useState("");
  const [saving, setSaving] = React.useState(false);

  let isSuperman = false;

  try {
    const token = localStorage.getItem("token");
    const decoded = jwtDecode(token);
    isSuperman = Boolean(decoded?.permisoVertodoExpenses);
  } catch {}

  let canPrint = false;

  try {
    const token = localStorage.getItem("token");
    const decoded = jwtDecode(token);

    const isSignedByEmployee = [
      "signed_employee",
      "signed_manager",
      "closed",
    ].includes(document?.Status);

    canPrint = isSignedByEmployee;
  } catch {
    canPrint = false;
  }

  const handlePrint = async () => {
    try {
      const token = localStorage.getItem("token");

      const res = await fetch(`${API_URL}/api/expenses/${document.id}/pdf`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!res.ok) {
        throw new Error("No autorizado o error generando PDF");
      }

      const blob = await res.blob();
      const url = window.URL.createObjectURL(blob);

      window.open(url, "_blank");
    } catch (e) {
      alert("No se pudo generar el PDF del justificante");
    }
  };

  const handleAccount = async () => {
    if (!numeroAsiento.trim()) return;

    try {
      setSaving(true);
      await accountExpenseDocument(document.id, numeroAsiento);
      window.location.reload(); // simple y seguro
    } catch (e) {
      alert(e?.response?.data?.error || "Error al contabilizar el documento");
    } finally {
      setSaving(false);
    }
  };

  return (
    <Box sx={{ mb: 2, display: "flex", gap: 2, alignItems: "center" }}>
      <Chip label={document.Status} color={getStatusColor(document.Status)} />

      <Box sx={{ flex: 1 }}>
        <Box sx={{ display: "flex", gap: 2, alignItems: "center" }}>
          <Typography variant="h6">
            Documento {document.DocumentNumber}
          </Typography>

          <Typography
            variant="body2"
            sx={{ fontWeight: "bold", color: "primary.main" }}
          >
            Creado: {new Date(document.createdAt).toLocaleDateString("es-ES")}
          </Typography>
        </Box>

        <Typography variant="body2" color="text.secondary">
          Solicitado por:{" "}
          <strong>{document.User?.username || document.User?.email}</strong>
        </Typography>
      </Box>

      {/* 📘 Contabilidad */}

      {isSuperman && document.Status === "closed" && (
        <Box>
          {!document.Contabilizado ? (
            <Box sx={{ display: "flex", gap: 2, alignItems: "center" }}>
              <TextField
                label="Número de asiento"
                size="small"
                value={numeroAsiento}
                onChange={(e) => setNumeroAsiento(e.target.value)}
              />
              <Button
                variant="contained"
                color="secondary"
                onClick={handleAccount}
                disabled={saving || !numeroAsiento.trim()}
              >
                Contabilizar
              </Button>
            </Box>
          ) : (
            <Box sx={{ color: "success.main", fontWeight: "bold" }}>
              📘 Contabilizado — Asiento: {document.NumeroAsiento}
            </Box>
          )}
        </Box>
      )}

      {canPrint && (
        <Button
          variant="outlined"
          startIcon={<PrintIcon />}
          onClick={handlePrint}
        >
          Imprimir justificante
        </Button>
      )}
    </Box>
  );
};

export default ExpenseDocumentHeader;
